import React from 'react';
import FormRadio from '@app/component/form/input/radio/FormRadio';


const AlertFilterLengthOfStayField: React.FunctionComponent<{ form: any }> = ({form}) => {

    return <>
        <p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Length of Stay</p>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
            <FormRadio name={`filter.lengthOfStay`} form={form} isRequired options={[
                {label: "1 Night", value: "1"},
                {label: "2 Nights", value: "2"},
                {label: "3 Nights", value: "3"},
                {label: "4 Nights", value: "4"},
                {label: "5 Nights", value: "5"},
                {label: "6 Nights", value: "6"},
                {label: "7 Nights", value: "7"},
            ]}/>
        </div>
    </>
}

export default AlertFilterLengthOfStayField;